import { Typography, Stack, Box, Tooltip, Divider } from '@mui/material';


export default function TableMetric( { metric, idx, showDivider, direction = 'horizontal' } ) {
    const isHorizontal = direction === 'horizontal';

    return (
        <Box display={isHorizontal ? 'flex' : 'block'}>
            <Tooltip title={metric.tooltip} arrow>
                <Box display="flex" alignItems="center" px={2} py={0.75} sx={{ width: 1, gap: 0.75 }}>
                    <Box sx={{ color: 'text.secondary', display: 'inline-flex', '& svg': { fontSize: 18 } }}>
                        {metric.icon}
                    </Box>
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        noWrap
                        align="left"
                        sx={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}
                    >
                        {metric.label}
                    </Typography>
                    <Typography variant="caption" fontWeight={700} noWrap sx={{ ml: 1 }}>
                        {metric.value}
                    </Typography>
                </Box>
            </Tooltip>
        </Box>
    );
}